import { isDefined } from "./common";

export function stripNullishObject<T extends Record<string, any>>(value: Partial<T>) {
  if (!isDefined(value)) {
    return {};
  }

  try {
    return Object.fromEntries(Object.entries(value).filter(([, propValue]) => isDefined(propValue)));
  } catch {
    return {};
  }
}
